import React, { FC } from 'react';

import { Video } from 'components/base';

import { VideoModule as IVideoModule } from 'types';

interface Props {
  module: IVideoModule;
}

const VideoModule: FC<Props> = ({ module }) => {
  return (
    <div className="VideoModule flex">
      <Video video={module} isFullWidth showVideoControl />
    </div>
  );
};

export default VideoModule;
